import { useEffect } from "react";


export default function ImagePasteListener({ onImagePaste }: { onImagePaste: (file: File) => void }) {

    useEffect(() => {
        const handlePaste = (e: ClipboardEvent) => {
            if (!e.clipboardData) return;

            const items = e.clipboardData.items;
            if (!items) return;

            for (const item of items) {
                // 检查是否是图片
                if (item.type.indexOf("image") !== -1) {
                    const file = item.getAsFile();
                    if (file) {
                        onImagePaste(file); // 回调
                    }
                }
            }
        };

        window.addEventListener("paste", handlePaste);
        return () => window.removeEventListener("paste", handlePaste);
    }, [onImagePaste]);

    return null;
}
